import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
type PreviewPaneProps = {
  children: ReactNode;
  /** Applied to the inner column, not the pane, so a sticky offset pins the caption and the frame together. */
  className?: string;
  /** Grows to fill a flex column below its siblings, for a caller whose pane is not the row's own flex child. */
  fill?: boolean;
};
const PreviewPane = t0 => {
  const $ = _c(16);
  const {
    children,
    className,
    fill: t1
  } = t0;
  const fill = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "nodePreview"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t2);
  let t3;
  if ($[1] !== fill) {
    t3 = cx("shrink-0 rounded bg-senary px-4 pt-4 pb-6 md:w-[520px]", {
      grow: fill
    });
    $[1] = fill;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== className) {
    t4 = cx("flex flex-col gap-3", className);
    $[3] = className;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t(_temp);
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <p className="text-label-2 text-primary">{t5}</p>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== children || $[10] !== t4 || $[11] !== t6) {
    t7 = <div className={t4}>{t6}{children}</div>;
    $[9] = children;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t7) {
    t8 = <aside className={t3}>{t7}</aside>;
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
export default PreviewPane;
export type { PreviewPaneProps };
function _temp($) {
  return $.title;
}